import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import ProductHeroMarketPlaceBlockData from "../../../Models/Content/ProductHeroMarketPlaceBlockData";
import ProductHeroMarketPlace from "./ProductHeroMarketPlace";

export default class ProductHeroMarketPlaceBlock extends EpiComponent<ProductHeroMarketPlaceBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["product-hero-marketplace-block"];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <ProductHeroMarketPlace iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}

